import { Field, FieldProps } from 'formik';
import { Grid } from '@mui/material';
import { PoolTypography } from '@synergy/components';
import { fields } from '@synergy/utils';

import { OptionCard } from '../../../../../../common/components/option-card/option-card';
import { ProductDetailOverviewFormValues } from '../models/product-detail-overview-form-values';

export const ProductDetailOverviewSectionSettings = () => {
    const fieldNames = fields<ProductDetailOverviewFormValues>();

    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.product.detail.settings" />

            <Grid container={true} columnSpacing={2}>
                <Grid item={true} xs={6}>
                    <Field name={fieldNames.isNormArticle}>
                        {({ field }: FieldProps<boolean>) => (
                            <OptionCard {...field}>
                                <PoolTypography typography="body1" id="app.product.detail.settings.card.normArticle" />
                            </OptionCard>
                        )}
                    </Field>
                </Grid>
                <Grid item={true} xs={6}>
                    <Field name={fieldNames.isEcoProduct}>
                        {({ field }: FieldProps<boolean>) => (
                            <OptionCard {...field}>
                                <PoolTypography typography="body1" id="app.product.detail.settings.card.ecoProduct" />
                            </OptionCard>
                        )}
                    </Field>
                </Grid>
                <Grid item={true} xs={6}>
                    <Field name={fieldNames.preventImportDeletion}>
                        {({ field }: FieldProps<boolean>) => (
                            <OptionCard {...field}>
                                <PoolTypography
                                    typography="body1"
                                    id="app.product.detail.settings.card.preventImportDeletion"
                                />
                            </OptionCard>
                        )}
                    </Field>
                </Grid>
                <Grid item={true} xs={6}>
                    <Field name={fieldNames.isPrioritizedInSearch}>
                        {({ field }: FieldProps<boolean>) => (
                            <OptionCard {...field}>
                                <PoolTypography
                                    typography="body1"
                                    id="app.product.detail.settings.card.prioritizedInSearch"
                                />
                            </OptionCard>
                        )}
                    </Field>
                </Grid>
            </Grid>
        </>
    );
};
